import { PUBLIC_DIFFUSION_API_ENDPOINT } from '$env/static/public';

export type ConnectedApp = {
	grant_id: string;
	client_id: string;
	client_name: string;
	scopes: string[];
	created_at: string;
	last_used_at: string | null;
};

export async function getConnectedApps(token: string): Promise<ConnectedApp[]> {
	const response: Response = await fetch(`${PUBLIC_DIFFUSION_API_ENDPOINT}/oauth/connected-apps`, {
		headers: { Authorization: `Bearer ${token}` }
	});
	if (!response.ok) {
		throw new Error(`Failed to load connected apps: HTTP ${response.status}`);
	}
	const body: { connected_apps: ConnectedApp[] } = await response.json();
	return body.connected_apps;
}

export async function disconnectConnectedApp(token: string, grantId: string): Promise<void> {
	const response: Response = await fetch(
		`${PUBLIC_DIFFUSION_API_ENDPOINT}/oauth/connected-apps/${encodeURIComponent(grantId)}`,
		{
			method: 'DELETE',
			headers: { Authorization: `Bearer ${token}` }
		}
	);
	if (!response.ok) {
		throw new Error(`Failed to disconnect app: HTTP ${response.status}`);
	}
}
